import { addXAuthTokenHeaders } from '@common/apis/customAddHeaders';
import customStorageAdapter from '@common/apis/customStorageAdpter';
import { createAlova } from 'alova';
import GlobalFetch from 'alova/GlobalFetch';
import ReactHook from 'alova/react';

interface AlovaInstanceProps {
  msUrl: string;
  headersBeforeRequest?: object;
  throwOnErrorStatus?: boolean;
}

export const alovaInstancePartners = ({ msUrl, headersBeforeRequest = {}, throwOnErrorStatus = false }: AlovaInstanceProps) =>
  createAlova({
    statesHook: ReactHook,
    requestAdapter: GlobalFetch(),
    baseURL: msUrl,
    storageAdapter: customStorageAdapter,
    responded: {
      onSuccess: async (response: Response) => {
        if (throwOnErrorStatus && response.status >= 400) {
          let errorBody;
          try {
            errorBody = await response.json();
          } catch {
            errorBody = { status: response.status, statusText: response.statusText };
          }
          throw errorBody;
        }

        try {
          const blob = await response.blob();
          if (blob) {
            return blob;
          }

          const json = await response.json();
          if (response.status >= 400) {
            throw json;
          }

          return json;
        } catch (err) {
          const stringifyResponse = JSON.stringify(response);
          const json = await JSON.parse(stringifyResponse);
          if (response.status >= 400) {
            throw json;
          }
          return json;
        }
      },
    },
    async beforeRequest(method) {
      if (msUrl?.includes('geminio')) return;

      method.config.headers = { ...headersBeforeRequest };
      await addXAuthTokenHeaders(method);
    },
  });
